/**
 * Request browser notification permission.
 * Call early in app lifecycle (e.g. onCreate of main page).
 * Returns 'granted', 'denied', or 'default'.
 */
export const requestBrowserPermission = async function () {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'denied'
  if (Notification.permission === 'granted') return 'granted'
  if (Notification.permission === 'denied') return 'denied'
  return Notification.requestPermission()
}
